import baseAPI from '../../axiosApi'

const api={
    list:'/api-ir/template/course/list',
    add:'/api-ir/template/course/add',
    update:'/api-ir/template/course/edit',
    del:'/api-ir/template/course/delete/',
}
// 查询课程列表
export function list (data) {
    return baseAPI.axiosData(api.list,'get',data)
}
// 新增课程
export function plus (data) {
    return baseAPI.axiosData(api.add,'post',data)
}
// 修改课程
export function update (data) {
    return baseAPI.axiosData(api.update,'put',data)
}
// 删除课程
export function del (id) {
    return baseAPI.axiosData(api.del+id,'delete')
}